import NewLoan from "./NewLoan";

export default NewLoan